import script from "./MonacoEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MonacoEditor.vue?vue&type=script&setup=true&lang=js"

import "./MonacoEditor.vue?vue&type=style&index=0&id=74a9fa02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a9fa02"]])

export default __exports__